// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sidebarWithTextAndCta":"_3j5f1_","innerWrapper":"_1aS-OR","heading":"puZU_l","ctaButton":"_2Pc4qN","wide":"_13G7lv","link":"DiG_W0","sidebarRte":"uzNPRD"};